import { Grid, CardContent } from "@mui/material";
import { IFullFlight } from "@vmosolutions/oc-interfaces";
import { FormHeader } from "../helpers";
import { DisplayEventComments } from "src/pages/CommentEditor/DisplayEventComments";

interface ICommentsTabProps {
  fullFlight: IFullFlight; // Id of the flight to retrieve and edit if provided.
  setLoadedFlight: (flightValues: IFullFlight) => void;
  updateTabState: (dirtyStatus: boolean) => void; // update parent with dirty status.
  mosaicId: string;
  setAPICallStatus: (statusMessage: string) => void;
}

/**
 * Flight Comments Tab
 * @param props -
 */
export const CommentsTab = (props: ICommentsTabProps): JSX.Element => {
  const { fullFlight, setLoadedFlight, updateTabState, mosaicId, setAPICallStatus } = props;
  const { _id, comments } = fullFlight ?? {};
  const subtitle = `(${comments?.length ?? 0})`;

  return (
    <CardContent id={`${mosaicId}-comments-editor`} className="form_card comments">
      <Grid container direction="column">
        <FormHeader title="Comments" subtitle={subtitle} />
        {fullFlight ? (
          <DisplayEventComments
            windowId={mosaicId}
            isFlight={true}
            eventId={_id}
            comments={comments}
            setLoadedFlight={setLoadedFlight}
            updateTabState={updateTabState}
          />
        ) : null}
      </Grid>
    </CardContent>
  );
};
